import { GoogleLogout } from 'react-google-login';

const clientId = '508890783137-6r2bcmgrbhcr9dciqlpqog8998561mku.apps.googleusercontent.com'; // Replace with OUR Google Client ID

function Logout() {

    const onSuccess = () => {
        console.log('Logout made successfully');
    }

    return (
        <div id="signout-button">
            <GoogleLogout
                clientId={clientId}
                buttonText={"Log Out"}
                onLogoutSuccess={onSuccess}
            />
        </div>
    )
}

export default Logout;